import { connect } from "react-redux";
import * as Redux from "redux";
import * as actions from "../../actions";

import { StoreVisits as StoreVisitsConstants } from "../../constants";
import TopStoresTable from "./component";

export module StoreVisits {
  export interface TopStoreVisitsActions {
    getTopStoresData: (
      flyer_run_ids: number[],
      start_date: string,
      end_date: string
    ) => void;
  }
  export interface TopStoreVisitsProps {
    startDate: string;
    endDate: string;
    publicationIds: number[];
    topStoresData: StoreVisitsConstants.TopStoreData[];
  }
}

export const mapStateToProps = (
  state: any,
  props: any
): StoreVisits.TopStoreVisitsProps => {
  return {
    topStoresData: state.storeVisits.topStoresData,
    startDate: state.storeVisits.startDate,
    endDate: state.storeVisits.endDate,
    publicationIds: state.storeVisits.publicationIds
  };
};

export const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): StoreVisits.TopStoreVisitsActions => {
  return {
    ...Redux.bindActionCreators(
      {
        getTopStoresData: actions.getTopStoresData
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TopStoresTable);



// WEBPACK FOOTER //
// ./client/modules/StoreVisits/components/TopStoresTable/container.ts